<template>
  <div>
    <el-upload
        ref="upload"
        class="upload-demo"
        action="/"
        :auto-upload="false"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-progress="onFileProgress"
        :before-remove="beforeRemove"
        :on-exceed="handleExceed"
        :http-request="uploadFile"
        :file-list="fileList"
        multiple>
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
    </el-upload>
    <el-button @click="uploadSubmit">上传服务器</el-button>
  </div>
</template>

<script>
import {fileSplitFormData,fileMd5} from "@/assets/scripts/uploadResume";
import $md5 from 'js-md5';
export default {
  name: "uploadResume",
  data(){
    return {
      fileList:[]
    };
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log('handlePreview---->',file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      console.log(fileList);
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    uploadFile(options){
      let file = options.file;
      let url = '/admin/material/uploadResume';
      let md5_1mb = '';
      let group_id = 1,dir_id = 1,type = file.type.indexOf('video/') >= 0 ? 1 : 2;
      fileMd5(file).then(res => {
        console.log("fileMd5========>", res);
        md5_1mb = res;
        return fileSplitFormData(file, 1048576*2, url);
      }).then(res => {
        console.log('uploadFlickerValidate--->',res);
        let fileSplit = res.files;
        let chunks = res.chunks;
        let params = {
          md5_1mb: md5_1mb,
          md5_first: fileSplit[0].md5,
          md5_last: fileSplit[fileSplit.length - 1].md5,
          size: file.size,
          type: type,
          original_name: file.name,
          group_id: group_id,
          dir_id: dir_id,
        }
        return new Promise((resolve) => {
          this.$http.post("/admin/material/uploadFlickerValidate", params, res => {
            console.log(88888);
            let params = {isFlicker: res.isFlicker}
            !params.isFlicker && (params = {params, ...{fileSplit,chunks}});
            resolve(params);
          })
        });
        // console.log("fileSplitFormData");
        // console.log(file);
        // let params = {
        //   dir_id: 2,
        //   type: 2,
        //   name: file.name,
        //   md5_1mb: file.name,
        //   md5_first: fileSplit[0].md5,
        //   md5_last: fileSplit[fileSplit.length - 1].md5,
        //   chunks: res.chunks,
        //   size: file.size,
        //   ext:file.name.substr(file.name.lastIndexOf('.')+1)
        // };
        // fileSplit.forEach((item,index)=>{
        //   console.log('file-->', index, item.file);
        //   params.file = item.file;
        //   params.chunk_current = item.chunkCurrent;
        //   params.md5_current = item.md5;
        //   this.$http.upload(url, params, progress => {
        //     console.log(progress);
        //   }, response => {
        //     console.log(response);
        //   })
        // })
        // this.$http.upload(url, formData, (p) => {
        //   let percent = 100 * (p.loaded / p.total);
        //   console.log('percent----->', percent);
        // }, response => {
        //   console.log(response);
        // });
      }).then(res =>{
        console.log('res------->', res);
        if (!res.isFlicker) {
          let fileSplit = res.fileSplit;
          let params = {
            type: type,
            group_id: group_id,
            dir_id: dir_id,
            upload_id: $md5(md5_1mb+fileSplit[0].md5+fileSplit[fileSplit.length - 1].md5+file.size+'55'+new Date().getTime()),
            name: file.name,
            md5_1mb: md5_1mb,
            md5_first: fileSplit[0].md5,
            md5_last: fileSplit[fileSplit.length - 1].md5,
            chunks: res.chunks,
            size: file.size,
            ext:file.name.substr(file.name.lastIndexOf('.')+1)
          };
          console.log('fileSplit----> ', fileSplit);
          fileSplit.forEach((item,index)=>{
            console.log('file-->', index, item.file);
            params.file = item.file;
            params.chunk_current = item.chunkCurrent;
            params.md5_current = item.md5;
            console.log(params);
            this.$http.upload(url, params, progress => {
              console.log(progress);
            }, response => {
              console.log(response);
            })
          })
        }
        console.log("666666--->", res);
      }).catch(err => {
        console.log(err);
      })
      // fileSplitFormData(file, 1048576*8, url).then(res => {
      //   let fileSplit = res.files;
      //   console.log(file);
      //   let params = {
      //     dir_id: 2,
      //     type: 2,
      //     name: file.name,
      //     md5_1mb: file.name,
      //     md5_first: fileSplit[0].md5,
      //     md5_last: fileSplit[fileSplit.length - 1].md5,
      //     chunks: res.chunks,
      //     size: file.size,
      //     ext:file.name.substr(file.name.lastIndexOf('.')+1)
      //   };
      //   fileSplit.forEach((item,index)=>{
      //     console.log('file-->', index, item.file);
      //     params.file = item.file;
      //     params.chunk_current = item.chunkCurrent;
      //     params.md5_current = item.md5;
      //     this.$http.upload(url, params, progress => {
      //       console.log(progress);
      //     }, response => {
      //       console.log(response);
      //     })
      //   })
      //   // this.$http.upload(url, formData, (p) => {
      //   //   let percent = 100 * (p.loaded / p.total);
      //   //   console.log('percent----->', percent);
      //   // }, response => {
      //   //   console.log(response);
      //   // });
      // }).catch(err => {
      //   console.log(err);
      // })
      // this.$refs.upload.submit();
    },
    onFileProgress(event, file, fileList){
      console.log(66666);
      console.log(event, file, fileList);
    },
    uploadSubmit(){
      this.$refs.upload.submit();
    }
  }
}
</script>

<style scoped>

</style>
